import React from 'react';
import { injectIntl } from 'react-intl';
import { Enterprise } from '../../../entity/entity.types';
import { EntityDefendedEnterprises } from '../../../entity/defended-enterprises/EntityDefendedEnterprises';
import { AllLawyerEnterprisesModal } from '../../../modals/entity-lists/AllLawyerEnterprisesModal';
import { fetchEnterprises } from '../../lawyer.api';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { EntityDecisionListModal } from '../../../modals/entity-lists/EntityDecisionListModal';
import { withModal, WithModalProps } from '../../../components/modal/withModal';
import { InjectedIntlProps } from '../../../doctrine.types';

type Props = {
  lawyerId: string;
  lawyerName: string;
  displaySection: Function;
  decisionCount: number;
} & WithModalProps &
  InjectedIntlProps;

type State = {
  enterprises: Enterprise[];
  hasMore: boolean;
  pluralityState: number;
};

export class RawEnterprisesRepresentedByLawyer extends React.Component<
  Props,
  State
> {
  state: State = {
    enterprises: [],
    hasMore: false,
    pluralityState: 0,
  };

  source = 'lawyer_enterprises';

  wording = this.props.intl.formatMessage(
    { id: 'app.pages.lawyer.representing.wording' },
    { lawyerName: this.props.lawyerName },
  );

  async componentDidMount() {
    const { lawyerId, displaySection } = this.props;
    const { enterprises, hasMore, pluralityState } = (
      await fetchEnterprises(lawyerId)
    ).data;
    this.setState({ enterprises, hasMore, pluralityState }, () => {
      if (pluralityState > 0) {
        displaySection();
      }
    });
  }

  handleSeeMoreEnterprisesClick = () => {
    const { openModal, lawyerId, lawyerName } = this.props;
    openModal(modalProps => (
      <AllLawyerEnterprisesModal
        lawyerId={lawyerId}
        source={this.source}
        lawyerName={lawyerName}
        wording={this.wording}
        {...modalProps}
      />
    ));
    doctrineAnalytics('Professional SeeMoreEnterprises', {
      lawyer_id: this.props.lawyerId,
    });
  };

  handleClickDecision = (enterprise: Enterprise) => {
    const { openModal, lawyerId } = this.props;
    openModal(modalProps => (
      <EntityDecisionListModal
        entityName={enterprise.name}
        wording={this.wording}
        params={{
          siren: enterprise.siren,
          lawyerId,
        }}
        source={this.source}
        {...modalProps}
      />
    ));
    doctrineAnalytics('Entity SeeEntityDecisions', {
      source: this.source,
    });
  };

  render() {
    const { lawyerName, lawyerId, decisionCount } = this.props;
    const { pluralityState, enterprises, hasMore } = this.state;

    if (pluralityState === 0) {
      return null;
    }

    return (
      <EntityDefendedEnterprises
        enterprises={enterprises}
        pluralityState={pluralityState}
        entityName={`Maître ${lawyerName}`}
        entityType="lawyer"
        entityId={lawyerId}
        decisionCount={decisionCount}
        source={this.source}
        handleSeeMoreEnterprisesClick={
          hasMore ? this.handleSeeMoreEnterprisesClick : null
        }
        handleClickDecision={this.handleClickDecision}
        wording={this.wording}
      />
    );
  }
}

export const EnterprisesRepresentedByLawyer = withModal(
  injectIntl(RawEnterprisesRepresentedByLawyer),
);
